import React from 'react';
import Moment from 'moment-timezone';
import { extendMoment } from 'moment-range';
import { Grid, Header, Segment } from 'semantic-ui-react';
import { useWeather } from '../../_services';
import { WeatherChart } from '../../_components/chart/WeatherChart';

const moment = extendMoment(Moment);

export const DisplayWeather = () => {
  // Get weather forecast from 3 hours ago forward
  const nowAsHour = moment.utc().subtract(3, 'h');

  const timestamp = nowAsHour.format('YYYY-MM-DDTHH:mm') + 'Z';
  const weather = useWeather(
    'MATG8cccf336-dd41-4886-9696-27874a9d7680', // TDTODO parameterise this
    timestamp
  );
  const location = 'Mortimer Road';
  const source = weather.length ? weather[0].source : '-';

  return (
    <Segment>
      <Grid stretched>
        <Grid.Row>
          <Grid.Column>
            <Header as="h2">Weather</Header>
            <p>Source: {source}</p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Grid stretched>
        <Grid.Row>
          <Grid.Column>
            <WeatherChart weather={weather} location={location} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};
